import { render, staticRenderFns } from "./Lista.vue?vue&type=template&id=0146a6f8&scoped=true"
import script from "./Lista.vue?vue&type=script&lang=js"
export * from "./Lista.vue?vue&type=script&lang=js"
import style0 from "./Lista.vue?vue&type=style&index=0&id=0146a6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0146a6f8",
  null
  
)

export default component.exports